import React from 'react';

import type { TooltipProps } from '@mui/material';
import { Tooltip } from '@mui/material';
import { IS_APPLE } from 'src/helpers/environment';
import { getTypographyForSx } from 'src/theme';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  arrow: {
    '&::before': {
      border: `1px solid ${theme.appColors.rule}`,
    },
    color: theme.palette.common.white,
  },
  tooltip: {
    ...getTypographyForSx(theme.typography.caption),
    backgroundColor: theme.palette.common.white,
    border: `solid 1px ${theme.appColors.rule}`,
    /** Keyboard shortcut hints */
    kbd: {
      backgroundColor: theme.palette.grey[50],
      border: `solid 1px ${theme.palette.grey[100]}`,
      borderRadius: 2,
      /** Ensure characters like ⌘ are rendered properly on macOS. */
      fontFamily: IS_APPLE ? 'system-ui, sans-serif' : undefined,
      letterSpacing: IS_APPLE ? '0.05em' : undefined,
      padding: '1px 2px',
    },
    textAlign: 'center',
  },
}));

export function AlineTooltip(props: TooltipProps): JSX.Element {
  const { classes } = useStyles();
  const { children, ...tooltipProps } = props;

  return (
    <Tooltip
      disableInteractive
      classes={{
        arrow: classes.arrow,
        tooltip: classes.tooltip,
      }}
      {...tooltipProps}
    >
      {children}
    </Tooltip>
  );
}
